<template>
  <div
      class="student-poster__root"
      :class="[mapLayout, mainStyle]"
  >
    <div
        v-if="['style-0'].includes(mainStyle)"
        class="student-poster__nameWithGratis"
        :class="[mapLayout, mainStyle]"
    >
      <TxContent
          class="nameWithGratis"
          :content="nameWithGratis"
      ></TxContent>
    </div>
    <div
        v-if="['style-1'].includes(mainStyle)"
        class="student-poster__gratisText"
        :class="[mapLayout, mainStyle]"
    >
      <TxContent
          class="gratisText"
          :content="gratisText"
      ></TxContent>
    </div>
    <div
        v-if="['style-1','style-2','style-3','style-4',
        'style-5','style-6','style-7','style-8','style-9',
        'style-10','style-11','style-12'].includes(mainStyle)"
        class="student-poster__studentName"
        :class="[mapLayout, mainStyle]"
    >
      <TxContent
          class="studentName"
          :content="studentName"
      ></TxContent>
    </div>
    <div
        v-if="['style-1','style-2','style-3','style-4',
        'style-5','style-6','style-7','style-8','style-9',
        'style-10','style-11','style-12'].includes(mainStyle)"
        class="student-poster__studentCode"
        :class="[mapLayout, mainStyle]"
    >
      <TxContent
          class="studentCode"
          :content="studentCode"
      ></TxContent>
    </div>
    <div
        v-if="['style-1','style-2','style-6','style-9'].includes(mainStyle)"
        class="student-poster__swedenGratis"
        :class="[mapLayout, mainStyle]"
    >
      <TxContent
          class="swedenGratis"
          :content="swedenGratis"
      ></TxContent>
    </div>
    <div
        v-if="['style-4','style-8','style-10','style-12'].includes(mainStyle)"
        class="student-poster__gratisLoud"
        :class="[mapLayout, mainStyle]"
    >
      <TxContent
          class="gratisLoud"
          :content="gratisLoud"
      ></TxContent>
    </div>
    <div
        v-if="['style-3', 'style-7', 'style-11'].includes(mainStyle)"
        class="student-poster__studentWithYear"
        :class="[mapLayout, mainStyle]"
    >
      <TxContent
          class="studentWithYear"
          :content="studentWithYear"
      ></TxContent>
    </div>
    <div
        v-if="['style-5'].includes(mainStyle)"
        class="student-poster__studentText"
        :class="[mapLayout, mainStyle]"
    >
      <TxContent
          class="studentText"
          :content="studentText"
      ></TxContent>
    </div>
    <div
        v-if="['style-0'].includes(mainStyle)"
        class="student-poster-subtitle"
        :class="[mapLayout, mainStyle]"
    >
      <TxContent class="text" :content="studentWithYear"></TxContent>
    </div>
  </div>
</template>

<script>
import StudentPosterModule from "../store-mixin";
import StudentPosterMixin from "../mixins/student-poster.mixin";

export default {
  name: 'StudentPosterTitle',
  mixins: [StudentPosterModule(), StudentPosterMixin()],
}
</script>

<style scoped lang="scss">
.student-poster__root {
  color: #292929; // 0
  font-weight: normal;
  font-style: normal;
}

.student-poster {
  &__nameWithGratis {
    text-align: center;
    position: absolute;
    z-index: 999;

    &.style-0 {
      font-family: 'Just Lovely';

      bottom: 0;
      left: -2px;
      right: -2px;
      font-size: 142px;
      line-height: 213px;
    }
  }

  &__gratisText {
    text-align: center;
    position: absolute;
    z-index: 999;

    &.style-1 {
      color: #e73e1b;
      font-family: 'Darleston';

      top: 15px;
      left: 15px;
      right: 210px;
      font-size: 175px;
      line-height: 262px;
      letter-spacing: 2px;
    }
  }

  &__studentWithYear {
    text-align: center;
    position: absolute;
    z-index: 999;

    &.style-3 {
      font-family: 'FogtwoNo5';

      bottom: 35px;
      left: 0;
      right: 0;
      font-size: 80px;
      line-height: 120px;
      letter-spacing: 6px;
      text-transform: uppercase;
    }
    &.style-7 {
      font-family: 'Eufoniem One';
      bottom: 40px;
      left: 45%;
      right: 0;
      font-size: 75px;
      line-height: 112px;
      letter-spacing: 6px;
    }
    &.style-11 {
      font-family: 'Eufoniem One';
      bottom: 15px;
      left: 37%;
      right: 0;
      font-size: 100px;
      line-height: 150px;
      letter-spacing: 6px;
    }
  }

  &__studentText {
    text-align: center;
    position: absolute;
    z-index: 999;

    &.style-3 {
      font-family: 'Darleston';

      top: 15px;
      left: 15px;
      right: 210px;
      font-size: 175px;
      line-height: 262px;
      letter-spacing: 2px;
    }

    &.style-5 {
      font-family: 'Cinzel';

      bottom: 200px;
      left: 35px;
      right: 0;
      font-size: 80px;
      line-height: 120px;
      letter-spacing: 10px;
      text-transform: uppercase;
      writing-mode: vertical-lr;
      text-orientation: upright;
    }
  }

  &__studentName {
    text-align: center;
    position: absolute;
    z-index: 999;

    &.style-1 {
      font-family: 'FogtwoNo5';

      text-transform: uppercase;

      bottom: 50px;
      left: 15px;
      right: 15px;
      font-size: 270px;
      line-height: 405px;
      letter-spacing: 3px;
      //letter-spacing: 2px;
    }

    &.style-2 {
      font-family: 'Aku and Kamu';

      text-transform: uppercase;

      top: 50px;
      left: 15px;
      right: 15px;
      font-size: 200px;
      line-height: 300px;
      letter-spacing: 2px;
      //letter-spacing: 2px;
    }

    &.style-3 {
      font-family: 'FogtwoNo5';

      text-transform: uppercase;
      top: 5px;
      left: 15px;
      right: 15px;
      font-size: 200px;
      line-height: 300px;
      letter-spacing: 2px;
      //letter-spacing: 2px;
    }

    &.style-4 {
      font-family: 'Aku and Kamu';

      text-transform: uppercase;
      bottom: 80px;
      left: 15px;
      right: 15px;
      font-size: 240px;
      line-height: 360px;
      letter-spacing: 10px;
      //letter-spacing: 2px;
    }


    &.style-5 {
      font-family: 'Ants Valley Personal Use';

      top: 80px;
      left: 15px;
      right: 15px;
      font-size: 220px;
      line-height: 330px;
      letter-spacing: 2px;
      //letter-spacing: 2px;
    }

    &.style-6 {
      font-family: 'Futura BdCn BT';
      font-weight: 900;

      text-transform: uppercase;

      bottom: 90px;
      left: 15px;
      right: 15px;
      font-size: 160px;
      line-height: 240px;
      letter-spacing: 12px;
      //letter-spacing: 2px;
    }
    &.style-7 {
      font-family: 'Futura BdCn BT';
      font-weight: bold;

      text-transform: uppercase;
      top: 0px;
      left: 15px;
      right: 15px;
      font-size: 190px;
      line-height: 285px;
      letter-spacing: 14px;
      //letter-spacing: 2px;
    }

    &.style-8 {
      font-family: 'Aku and Kamu';

      text-transform: uppercase;
      bottom: 100px;
      left: 0;
      right: 0;
      font-size: 170px;
      line-height: 255px;
      letter-spacing: 8px;
      //letter-spacing: 2px;
    }

    &.style-9 {
      font-family: 'Aku and Kamu';

      text-transform: uppercase;

      top: 50px;
      left: 15px;
      right: 15px;
      font-size: 245px;
      line-height: 367px;
      letter-spacing: 12px;
      //letter-spacing: 2px;
    }
    &.style-10 {
      font-family: 'Futura BdCn BT';
      font-weight: bold;

      bottom: 97px;
      left: 15px;
      right: 15px;
      font-size: 220px;
      line-height: 330px;
      letter-spacing: 15px;
      color: #b5912e;
    }
    &.style-11 {
      font-family: 'Futura BdCn BT';
      font-weight: bold;

      text-transform: uppercase;
      top: -10px;
      left: 15px;
      right: 15px;
      font-size: 215px;
      line-height: 322px;
      letter-spacing: 20px;
    }
    &.style-12 {
      font-family: 'Futura BdCn BT';

      bottom: 75px;
      left: 15px;
      right: 15px;
      font-size: 195px;
      line-height: 292px;
      letter-spacing: 15px;
    }
  }

  &__studentCode {
    text-align: center;
    position: absolute;
    z-index: 999;

    &.style-1 {
      font-family: 'FogtwoNo5';

      bottom: 45px;
      left: 15px;
      right: 15px;
      font-size: 95px;
      line-height: 142px;
      letter-spacing: 5px;
      //letter-spacing: 2px;
    }

    &.style-2 {
      font-family: 'Aku and Kamu';

      top: 280px;
      left: 15px;
      right: 15px;
      font-size: 80px;
      line-height: 120px;
      letter-spacing: 5px;
      //letter-spacing: 2px;
    }

    &.style-3 {
      font-family: 'FogtwoNo5';

      top: 200px;
      left: 15px;
      right: 15px;
      font-size: 95px;
      line-height: 142px;
      letter-spacing: 7px;
    }

    &.style-4 {
      font-family: 'Aku and Kamu';

      bottom: 10px;
      left: 15px;
      right: 15px;
      font-size: 109px;
      line-height: 163px;
      letter-spacing: 4px;
      //letter-spacing: 2px;
    }

    &.style-5 {
      font-family: 'Ants Valley Personal Use';

      top: 300px;
      left: 245px;
      right: 15px;
      font-size: 90px;
      line-height: 135px;
      letter-spacing: 0px;
      //letter-spacing: 2px;
    }

    &.style-6 {
      font-family: 'Futura BdCn BT';
      font-weight: 900;
      bottom: 0;
      /*top: 335px;*/
      left: 15px;
      right: 15px;
      font-size: 120px;
      line-height: 180px;
      letter-spacing: 5px;
      //letter-spacing: 2px;
    }
    &.style-7 {
      font-family: 'Futura BdCn BT';
      font-weight: bold;
      top: 197px;
      left: 15px;
      right: 15px;
      font-size: 82px;
      line-height: 123px;
      letter-spacing: 2px;
      //letter-spacing: 2px;
    }

    &.style-8 {
      font-family: 'Aku and Kamu';

      bottom: 20px;
      left: 15px;
      right: 15px;
      font-size: 90px;
      line-height: 135px;
      letter-spacing: 5px;
      //letter-spacing: 2px;
    }

    &.style-9 {
      font-family: 'Eufoniem One';

      top: 335px;
      left: 15px;
      right: 15px;
      font-size: 120px;
      line-height: 180px;
      letter-spacing: 5px;
      //letter-spacing: 2px;
    }

    &.style-10 {
      font-family: 'Futura BdCn BT';
      font-weight: bold;
      bottom: 0px;
      left: 15px;
      right: 15px;
      font-size: 135px;
      line-height: 202px;
      letter-spacing: 8px;
      color: #b5912e;
    }
    &.style-11 {
      font-family: 'Futura BdCn BT';
      font-weight: bold;
      top: 215px;
      left: 15px;
      right: 15px;
      font-size: 95px;
      line-height: 142px;
      letter-spacing: 3px;
    }
    &.style-12 {
      font-family: 'Futura BdCn BT';

      bottom: 50px;
      left: 15px;
      right: 15px;
      font-size: 75px;
      line-height: 112px;
      letter-spacing: 3px;
    }
  }

  &__swedenGratis {
    text-align: center;
    position: absolute;
    z-index: 999;

    &.style-2 {
      font-family: 'Ants Valley Personal Use';


      bottom: 38px;
      left: 425px;
      right: 100px;
      font-size: 85px;
      line-height: 127px;
      letter-spacing: 3px;
      text-indent: 62px;
      line-height: 85px;
      text-align: left;
      //letter-spacing: 2px;
    }

    &.style-6 {
      font-family: 'Eufoniem One';

      top: 25px;
      left: -25px;
      right: 0px;
      font-size: 115px;
      line-height: 172px;
      letter-spacing: 3px;
      rotate: -1deg;
    }

    &.style-9 {
      font-family: 'Eufoniem One';

      bottom: 85px;
      left: 10px;
      right: 10px;
      font-size: 115px;
      line-height: 172px;
      letter-spacing: 3px;
    }
  }

  &__gratisLoud {
    text-align: center;
    position: absolute;
    z-index: 999;

    &.style-4 {
      font-family: 'Ants Valley Personal Use';

      top: 45px;
      left: 30px;
      right: 10px;
      font-size: 143px;
      line-height: 214px;
      letter-spacing: 10px;
    }

    &.style-8 {
      font-family: 'CIAO CIAO SOLID Alt';

      top: 45px;
      left: 10px;
      right: 10px;
      font-size: 115px;
      line-height: 172px;
      letter-spacing: 0px;
      text-transform: uppercase;
    }
    &.style-10 {
      font-family: 'Eufoniem One';
      bottom: 290px;
      left: 10px;
      right: 10px;
      font-size: 190px;
      line-height: 285px;
      letter-spacing: 5px;
      color: #b5912e;
    }
    &.style-12 {
      font-family: 'Eufoniem One';

      top: 170px;
      left: 10px;
      right: 10px;
      font-size: 190px;
      line-height: 285px;
      letter-spacing: 5px;
    }
  }

}

.student-poster-subtitle {
  text-align: center;
  position: absolute;
  z-index: 999;

  &.style-0 {
    padding-top: 50px;
    top: 165px;
    left: -2px;
    right: -2px;

    font-family: 'Sofia Pro';
    font-weight: bold;
    font-size: 42px;
    line-height: 63px;
  }

  &.style-1 {
    padding-top: 50px;
    top: 165px;
    left: -2px;
    right: -2px;

    font-family: 'FogtwoNo5';
    font-size: 42px;
    line-height: 63px;
  }
}

</style>

